export const apiUrl = (hostname) => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:3000';
  }

  if (process.env.NODE_ENV === 'staging') {
    return 'https://staging.quirinprivatbank.de';
  }

  if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test') {
    if (hostname.includes('localhost')) {
      return 'http://localhost:3000';
    }

    if (hostname.includes('quirion')) {
      return 'https://service.quirion.de';
    }
  }

  return 'https://ms.quirinprivatbank.de';
};

export const meilisearchConfigs = () => {
  if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test') {
    return {
      url: 'https://search.quirinprivatbank-vpn.customer.planetary-quantum.net',
      masterKey: '2a2ade65c85a0c61a4caf7e84cf4a872e9aae32e4860c751610b3940f4dcdd8d'
    }
  }

  return {
    url: 'https://search.staging.quirinprivatbank.de',
    masterKey: '8471af6a39c7bf5040347c4e9acc472eec7de1ce8f40a77d1bf1f7886366afe4'
  }
}



// WEBPACK FOOTER //
// ./env.js